<template>
  <div class="act-login">
    <div class="content">
      <div class="state">
        <img src="./imgs/success.png" alt="" />
        <div class="text">
          <span class="font16">成功!</span>
        </div>
        <div class="name">{{ phone }}</div>
        <p class="info">
          现金红包已发放,<span class="color-text" @click="downloadApp"
            >下载APP完成认证</span
          >就能领取啦
        </p>
        <div class="line"></div>
        <notice class="notice" />
        <div class="button-wrp">
          <div class="btn" @click="downloadApp">下载APP</div>
        </div>
        <div class="extra-info">
          <!-- <div class="line-lf"></div> -->
          <div class="ifo">您也可至应用商店搜索“长律”进行下载哦</div>
          <!-- <div class="line-rg"></div> -->
        </div>
        <div class="logo">
          <img src="./imgs/logo.png" alt="" />
        </div>
        <p class="footer-text">海量案源，尽在长律</p>
      </div>
    </div>
    <img class="bg" src="./imgs/login-bg.png" alt="" />
    <div class="wx-mask" ref="wxmask">
      <img src="./imgs/what_tip1.png" alt="" />
    </div>
  </div>
</template>

<script>
import { getConfig } from '@/api/index'
import notice from './notice'
import { POINT_CODE, BURY_POINT_TYPE } from '@/libs/config'
import { buriedChannelPoint } from '@/api/common'
export default {
  name: 'act-login',
  components: {
    notice,
  },
  data() {
    return {
      phone: '',
      checked: false,
      config: {},
      inviteSource: '',
      inviteSysUserId: '',
    }
  },
  beforeMount() {
    this.phone = this.$route.query.phone
    this.inviteSource = this.$route.query.inviteSource
    this.inviteSysUserId = this.$route.query.inviteSysUserId
    this.init()
  },
  methods: {
    init() {
      this.getConfig()
    },
    async buriedPointPage() {
      let params = {
        code: POINT_CODE.SPREAD_DOWNLOAD,
        type: BURY_POINT_TYPE.PAGE,
        extra: { inviteUserId: Number(this.inviteSysUserId) },
      }
      await buriedChannelPoint(params)
    },
    async getConfig() {
      let res = await getConfig()
      if (!res.code) {
        this.config = res.data
      }
    },
    downloadApp() {
      if (this.inviteSource == 2) {
        this.buriedPointPage()
      }
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isAndroid && !this.isWeiXin()) {
        window.location.href = this.config.downloadGfUrlApk
      } else if (isiOS) {
        window.location.href = this.config.downloadGfUrlIos
      }
    },
    isWeiXin() {
      const u = navigator.userAgent
      var ua = u.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.$refs.wxmask.style.display = 'block'
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.act-login {
  position: relative;
  background: #3e22cd;
  min-height: 100vh;
  ::v-deep .van-icon {
    color: #111111;
  }

  .content {
    display: flex;
    position: relative;
    z-index: 1;
    .state {
      margin: 0 auto;
      margin-top: 80px;
      text-align: center;
      background: #fff;
      padding: 20px;
      padding-top: 50px;
      box-sizing: border-box;
      width: 315px;
      box-shadow: 0px 4px 0px 0px rgba(30, 39, 125, 1);
      border-radius: 10px;
      img {
        width: 75px;
        height: 75px;
      }
      .text {
        margin-top: 16px;
        text-align: center;
        span {
          color: #999999;
          font-size: 14px;
        }
        .font16 {
          font-size: 18px;
        }
      }
      .name {
        margin-top: 32px;
        color: #111111;
        font-size: 20px;
      }
      .info {
        font-size: 12px;
        margin-top: 12px;
        color: #999;
        .color-text {
          color: #d4b37d;
        }
      }
      .line {
        min-height: 40px;
        max-height: 76px;
      }
      .buyer-show {
        margin: 0px auto;
        .notice-swipe {
          height: 18px;
          font-size: 13px;
          font-weight: 500;
          color: #51b4ff;
          line-height: 18px;
        }
      }
      .button-wrp {
        text-align: center;
        .btn {
          display: inline-block;
          width: 193px;
          height: 44px;
          line-height: 44px;
          color: #fff;
          background: linear-gradient(270deg, #d4b37d 0%, #f1d09b 100%);
          border-radius: 22px;
        }
      }
      .extra-info {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .line-lf {
          width: 45px;
          margin-right: 12px;
          border-bottom: 1px solid;
          border-image: linear-gradient(
              132deg,
              rgba(187, 196, 250, 0),
              rgba(187, 196, 250, 1)
            )
            1 1;
        }
        .ifo {
          color: #999;
          font-size: 12px;
        }
        .line-rg {
          width: 45px;
          margin-left: 12px;
          border-bottom: 1px solid;
          border-image: linear-gradient(
              270deg,
              rgba(187, 196, 250, 0),
              rgba(187, 196, 250, 1)
            )
            1 1;
        }
      }
      .logo {
        margin-top: 46px;
        img {
          width: 64px;
          height: 64px;
        }
      }
      .footer-text {
        font-size: 14px;
        color: #111;
        margin-top: 16px;
      }
    }
  }
  .bg {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .wx-mask {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 99;
    img {
      position: absolute;
      right: 20px;
      width: 200px;
    }
  }
}
</style>